var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page-wrap',[_c('error-page-content',{attrs:{"error-data":_vm.errorData}}),(_vm.isFooterShown)?_c('footer-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }